import { IClientContact } from '~/utils/interface/common';
// Others
import axiosClient from './axiosClient';
import { IBodyUpdate, IFileItem } from '~/utils/interface/common';
import { urlApiClient } from '~/utils/constants/apis';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IClient,
  IClientOverview,
  IClientQuote,
  IParamDetailClient,
  IQueryParamClient,
  IResponseInvoiceClient,
} from '~/utils/interface/client';
import { IAppointment } from '~/utils/interface/appointment';
import { ITask } from '~/utils/interface/task';
import { IActivity } from '~/utils/interface/activity';

const clientApi = {
  getListClient: (params: IQueryParamClient) => {
    const url = urlApiClient.getListClient;
    return axiosClient.get<IBaseResponse<IListDataResponse<IClient[]>>>(url, { params });
  },

  getDetailClient: (params: IParamDetailClient) => {
    const { clientId, type, query } = params;
    const url = urlApiClient.getDetailClient(clientId, type);
    return axiosClient.get<
      IBaseResponse<
        | IClientOverview
        | IListDataResponse<IClientQuote[]>
        | IListDataResponse<IAppointment[]>
        | IListDataResponse<ITask[]>
        | IListDataResponse<IFileItem[]>
        | IResponseInvoiceClient
        | IListDataResponse<IActivity[]>
        | IListDataResponse<IClientContact[]>
      >
    >(url, { params: query });
  },

  createClient: (formData: FormData) => {
    const url = urlApiClient.createClient;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  updateClient: (params: IBodyUpdate<FormData>) => {
    const { id, body } = params;
    const url = urlApiClient.updateClient(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  deleteClient: (id: string) => {
    const url = urlApiClient.deleteClient(id);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default clientApi;
